const $window = $(window);
const $mediaRow = $('.media-row.is-slider .row');

let lastBreakpoint;

const mediaRowInst = {
  initialize() {
    if (!$mediaRow.length) {
      return;
    }

    this.createListeners();
    this.calcDimensions();
  },

  createListeners() {
    $window.on('resize', () => {
      this.calcDimensions();
    });
  },

  calcDimensions() {
    const newBreakpoint = $window.width() < 768 ? 'sm' : 'lg';

    if (newBreakpoint !== lastBreakpoint) {
      lastBreakpoint = newBreakpoint;
      this.create();
    }
  },

  create() {
    if (lastBreakpoint === 'sm') {
      $mediaRow.not('.slick-initialized').slick({
        slidesToShow: 3,
        arrows: false,
        responsive: [
          {
            breakpoint: 409,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    } else {
      $mediaRow.each((i, mediaRow) => {
        const $mediaRowElement = $(mediaRow);

        if ($mediaRowElement.hasClass('slick-slider')) {
          $mediaRowElement.slick('unslick');
        }
      });
    }
  },
};

export default mediaRowInst;
